export const CVS_RETAILER_KEY = 10831; //CVS retailer key from Green Dot
